/*
 *  Copyright (C) UMISIS SOLUTIONS SRL - All Rights Reserved
 *  * Unauthorized copying of this file, via any medium is strictly prohibited
 *  * Proprietary and confidential
 *  * Written by Emanuel Gug <manu144x@gmail.com>, September 2018
 *
 */
import Echo from 'laravel-echo'
import Pusher from 'pusher-js';
window.Pusher = Pusher;
const csrf = document.querySelector('meta[name="csrf-token"]')?.content

export default {
  websocketsInit () {
    // Have this in case you stop running your laravel echo server
    window.Echo = new Echo({
      broadcaster: 'reverb',
      key: import.meta.env.VITE_REVERB_APP_KEY,
      forceTLS: true,
      wsHost: window.location.hostname,
      wsPort: 80,
      wssPort: 443,
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
      withCredentials: true,
      authEndpoint: '/broadcasting/auth',
      auth: { headers: { 'X-CSRF-TOKEN': csrf } }
    })
  }
}
